import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Толщина рамки `hairline` (0.5px, tailwind.config.ts) — своя: tailwind-merge её не
// знал, считал `border-hairline` цветом и выкидывал рядом с `border-ink-200`.
// У всех `Button variant="secondary"` и прочих мест с `cn(…border-hairline border-ink-…)`
// рамка пропадала (ревью PR #78, 15.10.2026).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'border-w': [{ border: ['hairline'] }],
      'border-w-x': [{ 'border-x': ['hairline'] }],
      'border-w-y': [{ 'border-y': ['hairline'] }],
      'border-w-t': [{ 'border-t': ['hairline'] }],
      'border-w-r': [{ 'border-r': ['hairline'] }],
      'border-w-b': [{ 'border-b': ['hairline'] }],
      'border-w-l': [{ 'border-l': ['hairline'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
